import { useGetAssignmentMarksQuery } from "../../../features/AssignmentMark/assignmentMarkApi";
import AssignmentMarkItem from "./AssignmentMarkItem";
import AssignmentMarkSummary from "./AssignmentMarkSummary";

export default function AssignmentMark() {
  const {
    data: assignmentMarks,
    isError,
    isLoading,
  } = useGetAssignmentMarksQuery();

  return (
    <div className="px-3 py-20 bg-opacity-10">
      <AssignmentMarkSummary assignmentMarks={assignmentMarks} />
      <div className="overflow-x-auto mt-4">
        <table className="divide-y-1 text-base divide-gray-600 w-full">
          <thead>
            <tr>
              <th className="table-th">Assignment</th>
              <th className="table-th">Date</th>
              <th className="table-th">Student Name</th>
              <th className="table-th">Repo Link</th>
              <th className="table-th">Mark</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-600/50">
            {isLoading && (
              <tr>
                <td className="text-center" colSpan="100%">
                  Loading assignment marks...
                </td>
              </tr>
            )}
            {isError && (
              <tr>
                <td className="text-center" colSpan="100%">
                  Failed to fetch assignment marks!
                </td>
              </tr>
            )}
            {!isLoading && assignmentMarks.length === 0 && (
              <tr>
                <td className="text-center" colSpan="100%">
                  No assignment marks found!
                </td>
              </tr>
            )}

            {assignmentMarks?.map((assignmentMark) => (
              <AssignmentMarkItem
                assignmentMark={assignmentMark}
                key={assignmentMark.id}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
